import { MyWellbeingReferralsPage } from "@features/wellbeing-referrals/components/MyWellbeingReferralsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/referrals/wellbeing/my")({
	component: Page,
    staticData: {
        crumb: {
            label: "My referrals",
        }
    }
});
function Page() {
	return <MyWellbeingReferralsPage />;
}
